import React from 'react';
import { useEffectOnce } from 'react-use';
import { useDispatch } from 'react-redux';
import * as actions from '../NetWorthReport/NetWorthReportActions';
import { NetWorthChart } from '../CommonComponents/OPL/charts/NetWorthChart/NetWorthChart';
import { useNetWorthChartData } from '../CommonComponents/OPL/charts/NetWorthChart/hooks/useNetWorthChartData';

interface Props {
  clientId: string;
  range: string;
}

export const OverviewNetworthChart = ({ clientId, range }: Props) => {
  const dispatch = useDispatch();
  const chartData = useNetWorthChartData(clientId, range);

  useEffectOnce(() => {
    dispatch(actions.fetch_data(null, clientId));
  });

  return <NetWorthChart data={chartData} />;
};
